import $ from "jquery";

/**
 * @description: 解析URL
 * @param {string} url
 * @return {Object}
 */
function getQueryObject(url) {
  url = url == null ? decodeURIComponent(window.location.href) : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @description: 页面参数格式化
 * @param {string} str
 * @return {Object}
 */
function toJson(str) {
  let ismore = str.includes("&");
  let data = {};
  if (ismore) {
    let arr = str.split("&");
    arr.forEach((item) => {
      let a = item.split("=");
      data[a[0]] = a[1];
    });
  } else {
    let a = str.split("=");
    data[a[0]] = a[1];
  }
  return data;
}

export { $, getQueryObject, toJson };
